<template>
  <div class="m-3">

    <div v-if="surveyComplete">
      <h1 class="is-size-3">Thank you for completing the post-event survey</h1>
      <p class="my-4">Your response has been saved. If you would like to make changes to your response click the link below.</p>
      <b-button @click="editResponses" type="is-primary">Edit My Responses</b-button>
    </div>


    <div v-if="!surveyId">
      <b-notification>
        There is no post-event survey for this event.
      </b-notification>
    </div>


    <div v-if="surveyId && !surveyComplete">
      <form class="registration-survey p-4">

        <h1 class="is-size-3 mb-5">Tell Us About Your Experience</h1>
        <!-- <h2 class="is-size-5 mb-4">{{ survey.activeQuestionsCount }} Post-Event Survey Questions</h2> -->


        <div v-if="isLoading">
          <h2 class="is-size-5 my-4 has-text-grey">Loading survey questions..</h2>
        </div>

        <div v-if="!isLoading">
          <div v-for="(component, index) in survey.components" :key="index">
            <SurveyComponent
                :component="component"
                :questionResponse="getQuestionResponse(component.questionId)"
                v-on:input="setQuestionResponse"
            />
          </div>

          <b-button @click="saveRegistrationSurvey" type="is-primary">Save Responses</b-button>
        </div>
      </form>
    </div>





  </div>
</template>

<script>
var debounce = require('lodash.debounce');

import SurveyComponent from './Survey/SurveyComponent.vue'
import meetingsMixin from "@/mixins/meetingsMixin";

export default {
  name: 'PostEventSurvey',
  mixins: [meetingsMixin],
  components: {
    SurveyComponent,
  },
  props: {
  },
  data: function () {
    return {
      survey: {},
      questionResponsesToSave: {},
      questionResponses: [],
      surveyComplete: false,
      surveyLoaded: false,
      responsesLoaded: false,
    }
  },
  methods: {
    loadSurvey () {

      if (!this.surveyId) {
        this.survey = null
        return
      }

      var body = {
        'id': this.surveyId,
      }

      this.$app.huddleLabsServerCall('meetings/survey/show', body)
          .then(result => {
            console.log(result);

            if (result && result.data) {
              this.survey = result.data
              this.surveyLoaded = true
            } else {
              this.survey = null
            }

            /* this.$buefy.toast.open({
                message: 'The registration questions are loaded.',
                type: 'is-info'
            }) */
          })
          .catch(error => {
            console.log('error', error)

            this.$buefy.toast.open({
              message: 'Something went wrong while loading the registration questions. Please try to reload this page.',
              type: 'is-danger'
            })
          });
    },
    loadExistingResponses () {

      if (!this.surveyId) {
        this.questionResponses = []
        return
      }

      var body = {
        'surveyId': this.surveyId,
        'attendeeId': this.attendeeId,
      }

      this.$app.huddleLabsServerCall('meetings/survey-response/show', body)
          .then(result => {
            console.log(result);

            if (result && result.data && result.data.responses) {
              this.questionResponses = result.data.responses
            } else {
              this.questionResponses = []
            }

            this.responsesLoaded = true

            /* this.$buefy.toast.open({
                message: 'Your registration responses are loaded.',
                type: 'is-info'
            }) */
          })
          .catch(error => {
            console.log('error', error)

            this.$buefy.toast.open({
              message: 'Something went wrong while loading your registration responses. Please try to reload this page.',
              type: 'is-danger'
            })
          });
    },
    getQuestionResponse(questionId) {
      // Find the matching response for this question
      let items = this.questionResponses.filter(function(resp) {
        return resp.questionId == questionId
      })

      // Create a response with an empty answer if an existing one not found
      if (items.length != 1) {
        return {
          questionId: questionId,
          answer: null
        }
      }

      // Return the matching response
      return items[0]
    },
    setQuestionResponse(questionId, answer) {
      console.log('setQuestionResponse: ' + questionId + ' = ' + answer)

      this.questionResponsesToSave[questionId] = answer;
    },
    getResponsesToSave () {
      let responses = []

      // Loop through the attributes of the object
      for (var [questionId, answer] of Object.entries(this.questionResponsesToSave)) {

        // If the answer is an array convert it to a string
        // so it can be properly stored in Salesforce
        if (Array.isArray(answer)) {
          answer = answer.join(';')
        }

        let response = {
          questionId: questionId,
          answer: answer
        }

        responses.push(response)
      }

      return responses
    },
    saveRegistrationSurvey () {
      this.saveRequest()
    },
    saveRequest () {
      var responses = this.getResponsesToSave()

      if (responses.length == 0) {
        this.$buefy.toast.open({
          message: 'No responses to save.',
          type: 'is-info'
        })

        this.$store.commit('meetings/MEETING_SURVEY_SET', true)
        this.meetingRouter()
      }

      var body = {
        'surveyId': this.surveyId,
        'attendeeId': this.attendeeId,
        'responses': responses
      }

      console.log(body);

      this.$app.huddleLabsServerCall('meetings/survey-response/save', body)
          .then(result => {
            // this.$store.commit('meetingSurveySet', true)
            // this.meetingRouter()
            this.surveyComplete = true
          })
          .catch(error => {
            console.log('error', error)

            this.$buefy.toast.open({
              message: 'Something went wrong while saving your registration responses. Please try again.',
              type: 'is-danger'
            })
          });
    },
    editResponses() {
      this.surveyComplete = false
      this.loadExistingResponses()
    }
  },
  mounted(){
    this.loadSurvey()
    this.loadExistingResponses()
  },
  computed: {
    attendeeId(){
      return this.$store.state.meetings.meetingInfo.attendeeId
    },
    surveyId(){
      if (!this.$store.state.meetings.meetingInfo.meeting.postEventSurvey) return null

      return this.$store.state.meetings.meetingInfo.meeting.postEventSurvey.id
    },
    isLoading() {
      if (!this.surveyId) return false

      return !this.surveyLoaded || !this.responsesLoaded
    },
  }
}

</script>

<style>


/* input:required, textarea:required, select:required {
    border-left-color: #f14668;
} */

input:invalid:required,  checkbox:invalid:required, textarea:invalid:required, select:invalid:required {
  border-left-color: #f14668;
  background: #feecf0;
  border-left-width: 4px;
}

/* input:valid, textarea:valid, select:valid {
    border-left-color: #48c774;
    border-left-width: 4px;
} */
</style>
